import UnlimitedAdvantages from 'components/global/UnlimitedAdvantages'
import Box, { BoxProps } from 'components/shared/Box'
import Text from 'components/shared/Text'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { CardEditionType } from 'store/api-slice/types'

interface RenewTitledAdvantagesProps extends BoxProps {
    cardEdition: CardEditionType
}

const RenewTitledAdvantages = ({
    cardEdition,
    ...props
}: RenewTitledAdvantagesProps) => {
    const { formatMessage } = useIntl()

    const title = useMemo(() => {
        const titleBlue = formatMessage({
            id: 'annual.renew.summary_bonuses_header_blue',
            defaultMessage:
                'Dodatkowo, kupując kartę Unlimited Blue w pakiecie z voucherem już teraz otrzymujesz:',
        })
        const titleRed = formatMessage({
            id: 'annual.renew.summary_bonuses_header_red',
            defaultMessage:
                'Dodatkowo, kupując kartę Unlimited Red w pakiecie z voucherem już teraz otrzymujesz:',
        })

        switch (cardEdition) {
            case 'blue':
                return titleBlue
            case 'red':
                return titleRed
            default:
                return ''
        }
    }, [cardEdition])

    return (
        <Box {...props}>
            <Text variant="body" color="grayscale_900">
                {title}
            </Text>
            <UnlimitedAdvantages cardEdition={cardEdition} isAlt />
        </Box>
    )
}

export default RenewTitledAdvantages
